var scrollTo = require('../../scrollTo.js');
var ease = require('ease-component');
var selectItem = require('./selectItem.js');

module.exports = function onMarkerClick(map, item) {
	var rect = item.el.getBoundingClientRect();
	var contRect = map.container.getElement().parentNode.parentNode.getBoundingClientRect();
	var y = Math.min(
		contRect.top + window.scrollY + contRect.height - window.innerHeight,
		rect.top + window.scrollY - 40
	);
	scrollTo(y, 300, ease.inCube, () => '');
	selectItem(map, item);
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/onMarkerClick.js
 **/